module.exports = __webpack_public_path__ + "img/wj01.af650191.png";